import React, { useEffect, useRef, useState } from "react";
import { X, PlayCircle } from "lucide-react";

// Trình phát video. videos: [{ title, url }] hoặc một videoUrl; mục có nhiều video (mỗi phần của bài
// một video) thì hiện danh sách phần bên dưới để chọn.
// onPlay(video, index): gọi mỗi khi bắt đầu phát một video (để ghi việc học)
const VideoPlayerModal = ({ videos: videoList, videoUrl, onClose, onPlay }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(0);
  }, [videoList, videoUrl]);

  const videos = videoList || (videoUrl ? [{ url: videoUrl }] : null);
  const playing = videos?.[Math.min(index, videos.length - 1)];
  const onPlayRef = useRef(onPlay);
  onPlayRef.current = onPlay;
  const playingUrl = playing?.url;
  useEffect(() => {
    if (playingUrl) onPlayRef.current?.(playing, index);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playingUrl, index]);

  if (!videos || videos.length === 0) return null;
  const current = videos[Math.min(index, videos.length - 1)];

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-2 md:p-4 animate-fade-in"
      onClick={onClose}
    >
      <div
        className="w-full max-w-4xl flex flex-col"
        style={{ maxWidth: "95vw" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="relative bg-black rounded-lg shadow-xl w-full aspect-video overflow-hidden"
          style={{ maxHeight: "75vh" }}
        >
          <button
            onClick={onClose}
            className="absolute top-2 right-2 bg-red-600 text-white rounded-full p-2 shadow-lg hover:bg-red-700 transition-colors duration-300 z-10"
            aria-label="Đóng video"
          >
            <X size={24} />
          </button>
          <iframe
            key={current.url}
            width="100%"
            height="100%"
            src={current.url}
            title={current.title || "Video bài giảng"}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="w-full h-full"
          ></iframe>
        </div>
        {videos.length > 1 && (
          <div className="mt-2 bg-white rounded-lg p-2 flex flex-col sm:flex-row sm:flex-wrap gap-1.5">
            {videos.map((v, i) => (
              <button
                key={v.url}
                onClick={() => setIndex(i)}
                className={`flex items-center text-left text-sm px-3 py-2 rounded-md ${
                  i === index
                    ? "bg-indigo-600 text-white"
                    : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                }`}
              >
                <PlayCircle size={16} className="mr-2 flex-shrink-0" />
                Phần {i + 1}: {v.title}
              </button>
            ))}
          </div>
        )}
      </div>
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          .animate-fade-in {
            animation: fadeIn 0.3s ease-out forwards;
          }
        `}
      </style>
    </div>
  );
};

export default VideoPlayerModal;
